<template>
  <el-form
    :model="user"
    ref="userForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">User Information</h4>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="Firstname" prop="first_name">
          <el-input v-model="user.first_name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item label="Lastname" prop="last_name">
          <el-input v-model="user.last_name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="Email" prop="email">
          <el-input type="email" v-model="user.email"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item label="Username" prop="username">
          <el-input
            v-model="user.username"
            :readonly="user.id ? true : false"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12" :xs="24">
        <el-form-item label="User Type" prop="user_type">
          <el-select v-model="user.user_type" @change="checkUserRole" placeholder="Select">
            <el-option
              v-for="item in userTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="12" :xs="24">
        <el-form-item v-if="show_customer" label="Client Name" prop="client_name">
          <el-select v-model="client_name" placeholder="Select">
            <el-option
              v-for="item in customer_data.data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="e-Signature" prop="url">
          <AppUploader
            url="/api/v1/inventory/fileupload/"
            accept="image/*"
            :params="{ q: 'signatures' }"
            @beforeUpload="beforeUpload"
            @uploadSuccess="handleUploadSuccess"
            >Upload Signature</AppUploader
          >
          <img
            v-if="user"
            :src="getImageSrc(user)"
            alt="user e-signature"
            style="max-width: calc(100% - 30px)"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="user.id">
      <el-col>
        <el-checkbox v-model="user.update_password"
          >Update user password</el-checkbox
        >
      </el-col>
    </el-row>
    <el-row v-show="user.update_password || !user.id" :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Password" prop="password">
          <el-input
            type="password"
            v-model="user.password"
            show-password
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-button class="mt-2" size="small" type="primary" @click="submit"
      >Save</el-button
    >
    <el-button size="small" @click="cancel">Cancel</el-button>
  </el-form>
</template>

<script>
import User from "@/models/User";
import Customer from "@/models/Customers";
export default {
  name: "user_info",
  computed: {
    userTypes() {
      return this.$store.getters["user/userTypes"];
    },
    rules() {
      var rules = User.rules();
      var rule = [
        {
          required: true,
          message: "Password is required.",
          trigger: "blur"
        }
      ];
      if (!this.user.id) {
        rules.password = rule;
        return rules;
      }
      if (!this.user.update_password) return rules;
      if (this.user.id && this.user.update_password) {
        rules.password = rule;
        return rules;
      }
      return {};
    }
  },
  data() {
    return {
      isLoading: false,
      user: new User(),
      client_name: null,
      pager: {
        page: 1,
        limit: 50
      },
      customer_data: [],
      show_customer: false
    };
  },
  watch: {
    customer_data: function(v) {
      this.client_name = v.data.find(o => o.user_id == this.user.id).id;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: "users" });
    },
    beforeUpload() {
      this.isLoading = true;
    },
    handleUploadSuccess(res, file) {
      this.isLoading = false;
      if (
        res.hasOwnProperty("data") &&
        res.data.hasOwnProperty("code") &&
        res.data.code == 200
      ) {
        let s = file.name.split(".");
        s.pop();
        this.user.url = res.data.msg;
        this.user.file = file;
      } else {
        this.$notify({
          type: "error",
          message: res.data.msg,
          position: "bottom-right"
        });
      }
    },
    submit() {
      this.$confirm("Are you sure you want to save this user information?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.$refs["userForm"].validate(valid => {
            if (!valid) {
              return false;
            }
            if (this.user.id) {
              this.isLoading = true;
              User.put(this.user).then(resp => {
                if (resp && resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "User information saved successfully.",
                    position: "bottom-right"
                  });
                  this.user.update_password = false;
                  this.user.password = "";
                  if(this.user.user_tye === 7) {
                    var cust = {
                      id: this.client_name,
                      user_id: this.user.id
                    }
                    Customer.update(cust);
                  }
                }
                this.isLoading = false;
              });
            } else {
              this.isLoading = true;
              User.create(this.user).then(resp => {
                if (resp && resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "User information saved successfully.",
                    position: "bottom-right"
                  });
                  if(this.user.user_tye === 7) {
                    var cust = {
                      id: this.client_name,
                      user_id: resp.user_id
                    }
                    Customer.update(cust);
                  }
                  this.$router.push({
                    name: "users"
                  });
                }
                this.isLoading = false;
              });
            }
          });
        })
        .catch(() => {});
    },
    getImageSrc(user) {
      if (user.file) {
        if ("raw" in user.file) return URL.createObjectURL(user.file.raw);
        else return "data:image/jpg;base64," + user.file.path;
      } else if (user.signature) {
        return "data:image/jpg;base64," + user.signature;
      }
      return "";
    },
    checkUserRole() {
      if(this.user.user_type === 7) {
          this.pager.page = 1;
          this.pager.limit = 99;
          Customer.list(this.pager).then(list => {
            if (list) this.customer_data = list;
          });
          this.show_customer = true;
          return false;
      }
      this.show_customer = false;
      this.customer_data = [];
      this.client_name = null;
    }
  },
  mounted() {
    this.$store.dispatch("user/getUserTypes");
    if (this.$route.params && this.$route.params.id) {
      this.isLoading = true;
      User.fetch(this.$route.params.id).then(resp => {
        this.user = new User(resp);
        this.isLoading = false;
        if(this.user.user_type == 7) {
          this.pager.page = 1;
          this.pager.limit = 99;
          Customer.list(this.pager).then(list => {
            if (list) this.customer_data = list;
          });
          this.show_customer = true;
        } 
      });
    }
  }
};
</script>
